export const mediumLinkIconConfig = {
  format: 'svg',
  type: 'link',
  size: 'medium',
};

export const smallLinkIconConfig = {
  format: 'svg',
  type: 'link',
  size: 'small',
};
